import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin.component';
import { ActivityLogComponent } from './activity-log.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      // ...other child routes
      { path: 'activity-log', component: ActivityLogComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {}
